import { StickyPanel } from '../../../../shared/ui/sticky-panel/StickyPanel';
import { FiltersPanel } from './FiltersPanel';

export function StickyFiltersPanel() {
  return (
    <StickyPanel
      stickyTopVar="--templates-sticky-top-offset"
      stickyTopFallback={100}
      width="var(--templates-filters-panel-width)"
    >
      <FiltersPanel />
    </StickyPanel>
  );
}
